import { RECIPE_SORT_OPTIONS, SORT_LABEL_KEYS, useT, type RecipeSortOption } from "@reciperoll/core";
import { ChevronDown } from "react-feather";

// Sort-by dropdown for recipe listings (same options as the iOS sort sheet).
// Generic over the option type so a page typed to the narrow RecipeSortOption
// union (Favourites/Library/QuickRecipes) and the collection page (which passes
// COLLECTION_SORT_OPTIONS incl. "Custom order") both type-check against onChange.
export function RecipeSort<T extends string = RecipeSortOption>({
  value,
  onChange,
  options,
}: {
  value: T;
  onChange: (value: T) => void;
  options?: readonly T[];
}) {
  const t = useT();
  const opts: readonly string[] = options ?? RECIPE_SORT_OPTIONS;
  return (
    <div className="relative inline-block">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        aria-label={t("sort.sortRecipes")}
        className="appearance-none bg-surface border border-line rounded-lg pl-3 pr-9 py-2 text-sm font-semibold text-ink-soft outline-none focus:border-terracotta cursor-pointer"
      >
        {opts.map((o) => (
          <option key={o} value={o}>
            {SORT_LABEL_KEYS[o] ? t(SORT_LABEL_KEYS[o]) : o}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-faint pointer-events-none" />
    </div>
  );
}
